import React from 'react';

interface Props {
	size: number;
}

export const StudentSupportIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>studentSupport</title>
		<path d='M2.13 20.58L2.32 16l-.13-.08a3.8 3.8 0 01-1.82-3.25V7.23a3.82 3.82 0 013.81-3.81h15.64a3.82 3.82 0 013.81 3.81v5.44a3.82 3.82 0 01-3.81 3.81H7zM4.18 4.25a3 3 0 00-3 3v5.44a3 3 0 001.42 2.54l.55.34L3 18.73l3.64-3.08h13.18a3 3 0 003-3V7.23a3 3 0 00-3-3z' />
		<path d='M7.92 11.72a1.44 1.44 0 010-2.87 1.44 1.44 0 110 2.87zm0-2a.61.61 0 000 1.21.61.61 0 100-1.21zM12 11.72a1.44 1.44 0 111.43-1.43A1.43 1.43 0 0112 11.72zm0-2a.61.61 0 10.6.61.6.6 0 00-.6-.65zM16.08 11.72a1.44 1.44 0 111.43-1.43 1.44 1.44 0 01-1.43 1.43zm0-2a.61.61 0 100 1.21.61.61 0 000-1.21z' />
	</svg>
);
